import { render, staticRenderFns } from "./CommissionPolicy.vue?vue&type=template&id=a990c776&scoped=true"
import script from "./CommissionPolicy.vue?vue&type=script&lang=js"
export * from "./CommissionPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a990c776",
  null
  
)

export default component.exports